<template>
    <div class="table-import">
        <ul class="table-import__tips fs-12 lh-20 p-8 color-333">
            <li>1.需严格按照示例表格上传，详细规则见附件。<a class="href fx-v-center" href="https://d.senguo.cc/ls/tpl/%E4%BC%9A%E5%91%98%E6%95%B0%E6%8D%AE%E8%A1%A8%E6%A0%BC-%E7%A4%BA%E4%BE%8B-2020-09-28.xlsx">（点击下载:<img src="../images/table_download_icon.svg" alt="download-icon">会员数据表格 (示例).xlxs）</a></li>
            <li>2.会员手机号在店铺内具有唯一性，如遇导入的新会员手机号与店铺原会员手机号重复，则会将信息进行合并，您可以自主选择覆盖规则。</li>
            <li class="color-red">3.若所上传的表格内有相同手机号会员/数据格式不符合规则，将会剔除此部分数据进行上传，并将为您用表格保留这部分数据，您可以下载后进行修改再次上传。</li>
        </ul>
        <begin-import class="mt-20" :type="1" />
    </div>
</template>

<script lang="ts">
import { createComponent, ref, onBeforeMount, onMounted } from '@vue/composition-api'
import BeginImport from '../components/begin_import.vue'

export default createComponent({
    setup: (props, ctx) => {

        return {

        }
    },

    components: {
        BeginImport
    }
})
</script>

<style lang="scss" scoped>
.table-import {
    &__tips {
        background-color: #f7f7f7;

        li > a {
            display: inline-flex;

            img {
                width: 18px;
            }
        }
    }
}
</style>
